module.exports = __webpack_public_path__ + "static/media/bookily.d2a2a8b9.jpg";